var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToolbarPolygon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_9_1",
    "data-name": "Component 9 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.683,
    height: 35.566,
    viewBox: "0 0 34.683 35.566",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, -224.766, 141.097)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M194.408-176.331l8.5-12.282,14.408,5.573s0,14.388,0,14.388l-14.408,4.787Z",
    transform: "translate(-4.103 -5.413)",
    fill: "none",
    stroke: "current",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    transform: "translate(196.356 -196.426)",
    fill: "current",
    stroke: "current",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.642,
    cy: 2.642,
    r: 2.642,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.642,
    cy: 2.642,
    r: 2.142,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    transform: "translate(210.389 -190.663)",
    fill: "current",
    stroke: "current",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.642,
    cy: 2.642,
    r: 2.642,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.642,
    cy: 2.642,
    r: 2.142,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    transform: "translate(210.686 -177.053)",
    fill: "current",
    stroke: "current",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.642,
    cy: 2.642,
    r: 2.642,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.642,
    cy: 2.642,
    r: 2.142,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    transform: "translate(196.093 -172.406)",
    fill: "current",
    stroke: "current",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.642,
    cy: 2.642,
    r: 2.642,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.642,
    cy: 2.642,
    r: 2.142,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    transform: "translate(187.915 -183.482)",
    fill: "current",
    stroke: "current",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.642,
    cy: 2.642,
    r: 2.642,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.642,
    cy: 2.642,
    r: 2.142,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbarPolygon);
export default __webpack_public_path__ + "static/media/toolbar-polygon.813ea301eb238c84def0107b952308a2.svg";
export { ForwardRef as ReactComponent };